// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'
import _find from 'lodash/find'

import getAllRequestsInProgress$ from './getAllRequestsInProgress'

export default (urls) => createSelector(
  [getAllRequestsInProgress$],
  (requests) => _filter(requests, (request) => {
    return _find(urls, (url) => {
      return ((request.url).indexOf(url) === 0)
    })
  })
)
